import { render, staticRenderFns } from "./PackageReview.vue?vue&type=template&id=33b13057&scoped=true"
import script from "./PackageReview.vue?vue&type=script&lang=js"
export * from "./PackageReview.vue?vue&type=script&lang=js"
import style0 from "./PackageReview.vue?vue&type=style&index=0&id=33b13057&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b13057",
  null
  
)

export default component.exports